/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { UserContext } from '@irian-ro/util-user';

//const starting in uppercase in order to have the same API as with classes
export const IsLoggedInGuard: CanMatchFn = () => {
  const token = inject(LocalStorageService).retrieve('authenticationToken');
  const router = inject(Router);
  const userContext = inject(UserContext);
  const translate = inject(TranslateService);
  const config = {
    accessDeniedPath: 'accessdenied',
    loginPath: 'auth/login',
  };

  if (!token) {
    const url = router.getCurrentNavigation()?.initialUrl.toString();
    return router.navigate([config.loginPath], {
      queryParams: { returnUrl: url },
    });
  }

  return userContext.getLoggedInUserFromServerIfNotPresent(1000).pipe(
    map(() => true),
    catchError((errorResponse) => {
      if (errorResponse.error['error'] === 'invalid_token') {
        const statusMessages = [];
        statusMessages.push({
          severity: 'warn',
          summary: translate.instant('auth.errors.invalid_token'),
        });
        return of(router.parseUrl(`${config.loginPath}?statusMessages=${JSON.stringify(statusMessages)}`));
      }

      return of(router.parseUrl(config.accessDeniedPath));
    }),
    map((res) => {
      return res;
    })
  );
};
